module.exports = __webpack_public_path__ + "img/Group 363one2.a83b34b8.svg";